import React from 'react';
import { LoadingSpinner } from './LoadingSpinner';
import { ScreenDescription } from './ScreenDescription';
import { VerticalStack } from './VerticalStack';
import { designTokens } from '../../constants/designTokens';

interface LoadingStateProps {
  message?: string;
  className?: string;
  style?: React.CSSProperties;
}

export const LoadingState = React.memo(function LoadingState({
  message = 'Loading...',
  className = '',
  style,
}: LoadingStateProps) {
  return (
    <div
      className={`loading-state ${className}`}
      style={{
        padding: designTokens.spacing.xl,
        textAlign: 'center',
        ...style,
      }}
    >
      <VerticalStack spacing="lg" align="center">
        <LoadingSpinner size="lg" />
        <ScreenDescription>{message}</ScreenDescription>
      </VerticalStack>
    </div>
  );
});
